// source: no/jotta/openapi/updates/updates.v1.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

var google_api_annotations_pb = require('../../../../google/api/annotations_pb.js');
goog.object.extend(proto, google_api_annotations_pb);
var no_jotta_openapi_ping_pb = require('../../../../no/jotta/openapi/ping_pb.js');
goog.object.extend(proto, no_jotta_openapi_ping_pb);
var no_jotta_openapi_ref_pb = require('../../../../no/jotta/openapi/ref_pb.js');
goog.object.extend(proto, no_jotta_openapi_ref_pb);
var no_jotta_openapi_language_pb = require('../../../../no/jotta/openapi/language_pb.js');
goog.object.extend(proto, no_jotta_openapi_language_pb);
var no_jotta_openapi_avatar_pb = require('../../../../no/jotta/openapi/avatar_pb.js');
goog.object.extend(proto, no_jotta_openapi_avatar_pb);
goog.exportSymbol('proto.no.jotta.openapi.updates.v1.GetUpdatesRequest', null, global);
goog.exportSymbol('proto.no.jotta.openapi.updates.v1.GetUpdatesRequest.Sort', null, global);
goog.exportSymbol('proto.no.jotta.openapi.updates.v1.GetUpdatesResponse', null, global);
goog.exportSymbol('proto.no.jotta.openapi.updates.v1.Update', null, global);
goog.exportSymbol('proto.no.jotta.openapi.updates.v1.UpdateLastSeenRequest', null, global);
goog.exportSymbol('proto.no.jotta.openapi.updates.v1.UpdateLastSeenResponse', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.updates.v1.GetUpdatesRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.updates.v1.GetUpdatesRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.updates.v1.GetUpdatesRequest.displayName = 'proto.no.jotta.openapi.updates.v1.GetUpdatesRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.updates.v1.Update = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.updates.v1.Update, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.updates.v1.Update.displayName = 'proto.no.jotta.openapi.updates.v1.Update';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.updates.v1.GetUpdatesResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.no.jotta.openapi.updates.v1.GetUpdatesResponse.repeatedFields_, null);
};
goog.inherits(proto.no.jotta.openapi.updates.v1.GetUpdatesResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.updates.v1.GetUpdatesResponse.displayName = 'proto.no.jotta.openapi.updates.v1.GetUpdatesResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.updates.v1.UpdateLastSeenRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.updates.v1.UpdateLastSeenRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.updates.v1.UpdateLastSeenRequest.displayName = 'proto.no.jotta.openapi.updates.v1.UpdateLastSeenRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.updates.v1.UpdateLastSeenResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.updates.v1.UpdateLastSeenResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.updates.v1.UpdateLastSeenResponse.displayName = 'proto.no.jotta.openapi.updates.v1.UpdateLastSeenResponse';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.updates.v1.GetUpdatesRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.updates.v1.GetUpdatesRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.updates.v1.GetUpdatesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.updates.v1.GetUpdatesRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    limit: jspb.Message.getFieldWithDefault(msg, 1, 0),
    sort: jspb.Message.getFieldWithDefault(msg, 2, 0),
    cursor: jspb.Message.getFieldWithDefault(msg, 3, ""),
    language: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.updates.v1.GetUpdatesRequest}
 */
proto.no.jotta.openapi.updates.v1.GetUpdatesRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.updates.v1.GetUpdatesRequest;
  return proto.no.jotta.openapi.updates.v1.GetUpdatesRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.updates.v1.GetUpdatesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.updates.v1.GetUpdatesRequest}
 */
proto.no.jotta.openapi.updates.v1.GetUpdatesRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setLimit(value);
      break;
    case 2:
      var value = /** @type {!proto.no.jotta.openapi.updates.v1.GetUpdatesRequest.Sort} */ (reader.readEnum());
      msg.setSort(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setCursor(value);
      break;
    case 4:
      var value = /** @type {!proto.no.jotta.openapi.Language} */ (reader.readEnum());
      msg.setLanguage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.updates.v1.GetUpdatesRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.updates.v1.GetUpdatesRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.updates.v1.GetUpdatesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.updates.v1.GetUpdatesRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLimit();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getSort();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getCursor();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getLanguage();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.no.jotta.openapi.updates.v1.GetUpdatesRequest.Sort = {
  DESC: 0,
  ASC: 1
};

/**
 * optional int32 limit = 1;
 * @return {number}
 */
proto.no.jotta.openapi.updates.v1.GetUpdatesRequest.prototype.getLimit = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.no.jotta.openapi.updates.v1.GetUpdatesRequest} returns this
 */
proto.no.jotta.openapi.updates.v1.GetUpdatesRequest.prototype.setLimit = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional Sort sort = 2;
 * @return {!proto.no.jotta.openapi.updates.v1.GetUpdatesRequest.Sort}
 */
proto.no.jotta.openapi.updates.v1.GetUpdatesRequest.prototype.getSort = function() {
  return /** @type {!proto.no.jotta.openapi.updates.v1.GetUpdatesRequest.Sort} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.no.jotta.openapi.updates.v1.GetUpdatesRequest.Sort} value
 * @return {!proto.no.jotta.openapi.updates.v1.GetUpdatesRequest} returns this
 */
proto.no.jotta.openapi.updates.v1.GetUpdatesRequest.prototype.setSort = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional string cursor = 3;
 * @return {string}
 */
proto.no.jotta.openapi.updates.v1.GetUpdatesRequest.prototype.getCursor = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.updates.v1.GetUpdatesRequest} returns this
 */
proto.no.jotta.openapi.updates.v1.GetUpdatesRequest.prototype.setCursor = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional no.jotta.openapi.Language language = 4;
 * @return {!proto.no.jotta.openapi.Language}
 */
proto.no.jotta.openapi.updates.v1.GetUpdatesRequest.prototype.getLanguage = function() {
  return /** @type {!proto.no.jotta.openapi.Language} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.no.jotta.openapi.Language} value
 * @return {!proto.no.jotta.openapi.updates.v1.GetUpdatesRequest} returns this
 */
proto.no.jotta.openapi.updates.v1.GetUpdatesRequest.prototype.setLanguage = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.updates.v1.Update.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.updates.v1.Update.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.updates.v1.Update} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.updates.v1.Update.toObject = function(includeInstance, msg) {
  var f, obj = {
    plaintextTitle: jspb.Message.getFieldWithDefault(msg, 1, ""),
    deeplink: jspb.Message.getFieldWithDefault(msg, 2, ""),
    ref: (f = msg.getRef()) && no_jotta_openapi_ref_pb.ContentRef.toObject(includeInstance, f),
    isNew: jspb.Message.getBooleanFieldWithDefault(msg, 4, false),
    createdAtMillis: jspb.Message.getFieldWithDefault(msg, 5, 0),
    actorFullname: jspb.Message.getFieldWithDefault(msg, 6, ""),
    actorAvatar: (f = msg.getActorAvatar()) && no_jotta_openapi_avatar_pb.Avatar.toObject(includeInstance, f),
    thumbLink: jspb.Message.getFieldWithDefault(msg, 7, ""),
    id: jspb.Message.getFieldWithDefault(msg, 8, ""),
    plaintextBody: jspb.Message.getFieldWithDefault(msg, 9, ""),
    html: jspb.Message.getFieldWithDefault(msg, 10, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.updates.v1.Update}
 */
proto.no.jotta.openapi.updates.v1.Update.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.updates.v1.Update;
  return proto.no.jotta.openapi.updates.v1.Update.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.updates.v1.Update} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.updates.v1.Update}
 */
proto.no.jotta.openapi.updates.v1.Update.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPlaintextTitle(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setDeeplink(value);
      break;
    case 3:
      var value = new no_jotta_openapi_ref_pb.ContentRef;
      reader.readMessage(value,no_jotta_openapi_ref_pb.ContentRef.deserializeBinaryFromReader);
      msg.setRef(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsNew(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCreatedAtMillis(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setActorFullname(value);
      break;
    case 11:
      var value = new no_jotta_openapi_avatar_pb.Avatar;
      reader.readMessage(value,no_jotta_openapi_avatar_pb.Avatar.deserializeBinaryFromReader);
      msg.setActorAvatar(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setThumbLink(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setPlaintextBody(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setHtml(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.updates.v1.Update.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.updates.v1.Update.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.updates.v1.Update} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.updates.v1.Update.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPlaintextTitle();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getDeeplink();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getRef();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      no_jotta_openapi_ref_pb.ContentRef.serializeBinaryToWriter
    );
  }
  f = message.getIsNew();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
  f = message.getCreatedAtMillis();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
  f = message.getActorFullname();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getActorAvatar();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      no_jotta_openapi_avatar_pb.Avatar.serializeBinaryToWriter
    );
  }
  f = message.getThumbLink();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getPlaintextBody();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getHtml();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
};


/**
 * optional string plaintext_title = 1;
 * @return {string}
 */
proto.no.jotta.openapi.updates.v1.Update.prototype.getPlaintextTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.updates.v1.Update} returns this
 */
proto.no.jotta.openapi.updates.v1.Update.prototype.setPlaintextTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string deeplink = 2;
 * @return {string}
 */
proto.no.jotta.openapi.updates.v1.Update.prototype.getDeeplink = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.updates.v1.Update} returns this
 */
proto.no.jotta.openapi.updates.v1.Update.prototype.setDeeplink = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional no.jotta.openapi.ContentRef ref = 3;
 * @return {?proto.no.jotta.openapi.ContentRef}
 */
proto.no.jotta.openapi.updates.v1.Update.prototype.getRef = function() {
  return /** @type{?proto.no.jotta.openapi.ContentRef} */ (
    jspb.Message.getWrapperField(this, no_jotta_openapi_ref_pb.ContentRef, 3));
};


/**
 * @param {?proto.no.jotta.openapi.ContentRef|undefined} value
 * @return {!proto.no.jotta.openapi.updates.v1.Update} returns this
*/
proto.no.jotta.openapi.updates.v1.Update.prototype.setRef = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.no.jotta.openapi.updates.v1.Update} returns this
 */
proto.no.jotta.openapi.updates.v1.Update.prototype.clearRef = function() {
  return this.setRef(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.updates.v1.Update.prototype.hasRef = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional bool is_new = 4;
 * @return {boolean}
 */
proto.no.jotta.openapi.updates.v1.Update.prototype.getIsNew = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.no.jotta.openapi.updates.v1.Update} returns this
 */
proto.no.jotta.openapi.updates.v1.Update.prototype.setIsNew = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};


/**
 * optional int64 created_at_millis = 5;
 * @return {number}
 */
proto.no.jotta.openapi.updates.v1.Update.prototype.getCreatedAtMillis = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.no.jotta.openapi.updates.v1.Update} returns this
 */
proto.no.jotta.openapi.updates.v1.Update.prototype.setCreatedAtMillis = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional string actor_fullname = 6;
 * @return {string}
 */
proto.no.jotta.openapi.updates.v1.Update.prototype.getActorFullname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.updates.v1.Update} returns this
 */
proto.no.jotta.openapi.updates.v1.Update.prototype.setActorFullname = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional no.jotta.openapi.Avatar actor_avatar = 11;
 * @return {?proto.no.jotta.openapi.Avatar}
 */
proto.no.jotta.openapi.updates.v1.Update.prototype.getActorAvatar = function() {
  return /** @type{?proto.no.jotta.openapi.Avatar} */ (
    jspb.Message.getWrapperField(this, no_jotta_openapi_avatar_pb.Avatar, 11));
};


/**
 * @param {?proto.no.jotta.openapi.Avatar|undefined} value
 * @return {!proto.no.jotta.openapi.updates.v1.Update} returns this
*/
proto.no.jotta.openapi.updates.v1.Update.prototype.setActorAvatar = function(value) {
  return jspb.Message.setWrapperField(this, 11, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.no.jotta.openapi.updates.v1.Update} returns this
 */
proto.no.jotta.openapi.updates.v1.Update.prototype.clearActorAvatar = function() {
  return this.setActorAvatar(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.updates.v1.Update.prototype.hasActorAvatar = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional string thumb_link = 7;
 * @return {string}
 */
proto.no.jotta.openapi.updates.v1.Update.prototype.getThumbLink = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.updates.v1.Update} returns this
 */
proto.no.jotta.openapi.updates.v1.Update.prototype.setThumbLink = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string id = 8;
 * @return {string}
 */
proto.no.jotta.openapi.updates.v1.Update.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.updates.v1.Update} returns this
 */
proto.no.jotta.openapi.updates.v1.Update.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string plaintext_body = 9;
 * @return {string}
 */
proto.no.jotta.openapi.updates.v1.Update.prototype.getPlaintextBody = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.updates.v1.Update} returns this
 */
proto.no.jotta.openapi.updates.v1.Update.prototype.setPlaintextBody = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string html = 10;
 * @return {string}
 */
proto.no.jotta.openapi.updates.v1.Update.prototype.getHtml = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.updates.v1.Update} returns this
 */
proto.no.jotta.openapi.updates.v1.Update.prototype.setHtml = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.no.jotta.openapi.updates.v1.GetUpdatesResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.updates.v1.GetUpdatesResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.updates.v1.GetUpdatesResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.updates.v1.GetUpdatesResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.updates.v1.GetUpdatesResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    updateList: jspb.Message.toObjectList(msg.getUpdateList(),
    proto.no.jotta.openapi.updates.v1.Update.toObject, includeInstance),
    newUpdatesCount: jspb.Message.getFieldWithDefault(msg, 2, 0),
    cursor: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.updates.v1.GetUpdatesResponse}
 */
proto.no.jotta.openapi.updates.v1.GetUpdatesResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.updates.v1.GetUpdatesResponse;
  return proto.no.jotta.openapi.updates.v1.GetUpdatesResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.updates.v1.GetUpdatesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.updates.v1.GetUpdatesResponse}
 */
proto.no.jotta.openapi.updates.v1.GetUpdatesResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.no.jotta.openapi.updates.v1.Update;
      reader.readMessage(value,proto.no.jotta.openapi.updates.v1.Update.deserializeBinaryFromReader);
      msg.addUpdate(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setNewUpdatesCount(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setCursor(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.updates.v1.GetUpdatesResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.updates.v1.GetUpdatesResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.updates.v1.GetUpdatesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.updates.v1.GetUpdatesResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUpdateList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.no.jotta.openapi.updates.v1.Update.serializeBinaryToWriter
    );
  }
  f = message.getNewUpdatesCount();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getCursor();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * repeated Update update = 1;
 * @return {!Array<!proto.no.jotta.openapi.updates.v1.Update>}
 */
proto.no.jotta.openapi.updates.v1.GetUpdatesResponse.prototype.getUpdateList = function() {
  return /** @type{!Array<!proto.no.jotta.openapi.updates.v1.Update>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.no.jotta.openapi.updates.v1.Update, 1));
};


/**
 * @param {!Array<!proto.no.jotta.openapi.updates.v1.Update>} value
 * @return {!proto.no.jotta.openapi.updates.v1.GetUpdatesResponse} returns this
*/
proto.no.jotta.openapi.updates.v1.GetUpdatesResponse.prototype.setUpdateList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.no.jotta.openapi.updates.v1.Update=} opt_value
 * @param {number=} opt_index
 * @return {!proto.no.jotta.openapi.updates.v1.Update}
 */
proto.no.jotta.openapi.updates.v1.GetUpdatesResponse.prototype.addUpdate = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.no.jotta.openapi.updates.v1.Update, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.no.jotta.openapi.updates.v1.GetUpdatesResponse} returns this
 */
proto.no.jotta.openapi.updates.v1.GetUpdatesResponse.prototype.clearUpdateList = function() {
  return this.setUpdateList([]);
};


/**
 * optional int32 new_updates_count = 2;
 * @return {number}
 */
proto.no.jotta.openapi.updates.v1.GetUpdatesResponse.prototype.getNewUpdatesCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.no.jotta.openapi.updates.v1.GetUpdatesResponse} returns this
 */
proto.no.jotta.openapi.updates.v1.GetUpdatesResponse.prototype.setNewUpdatesCount = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string cursor = 3;
 * @return {string}
 */
proto.no.jotta.openapi.updates.v1.GetUpdatesResponse.prototype.getCursor = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.updates.v1.GetUpdatesResponse} returns this
 */
proto.no.jotta.openapi.updates.v1.GetUpdatesResponse.prototype.setCursor = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.updates.v1.UpdateLastSeenRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.updates.v1.UpdateLastSeenRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.updates.v1.UpdateLastSeenRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.updates.v1.UpdateLastSeenRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    lastSeenId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.updates.v1.UpdateLastSeenRequest}
 */
proto.no.jotta.openapi.updates.v1.UpdateLastSeenRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.updates.v1.UpdateLastSeenRequest;
  return proto.no.jotta.openapi.updates.v1.UpdateLastSeenRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.updates.v1.UpdateLastSeenRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.updates.v1.UpdateLastSeenRequest}
 */
proto.no.jotta.openapi.updates.v1.UpdateLastSeenRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setLastSeenId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.updates.v1.UpdateLastSeenRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.updates.v1.UpdateLastSeenRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.updates.v1.UpdateLastSeenRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.updates.v1.UpdateLastSeenRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLastSeenId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string last_seen_id = 1;
 * @return {string}
 */
proto.no.jotta.openapi.updates.v1.UpdateLastSeenRequest.prototype.getLastSeenId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.updates.v1.UpdateLastSeenRequest} returns this
 */
proto.no.jotta.openapi.updates.v1.UpdateLastSeenRequest.prototype.setLastSeenId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.updates.v1.UpdateLastSeenResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.updates.v1.UpdateLastSeenResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.updates.v1.UpdateLastSeenResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.updates.v1.UpdateLastSeenResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.updates.v1.UpdateLastSeenResponse}
 */
proto.no.jotta.openapi.updates.v1.UpdateLastSeenResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.updates.v1.UpdateLastSeenResponse;
  return proto.no.jotta.openapi.updates.v1.UpdateLastSeenResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.updates.v1.UpdateLastSeenResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.updates.v1.UpdateLastSeenResponse}
 */
proto.no.jotta.openapi.updates.v1.UpdateLastSeenResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.updates.v1.UpdateLastSeenResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.updates.v1.UpdateLastSeenResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.updates.v1.UpdateLastSeenResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.updates.v1.UpdateLastSeenResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};


goog.object.extend(exports, proto.no.jotta.openapi.updates.v1);
